import React from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { Trans } from 'react-i18next'
import { useGetLanguageMapperGif } from '../../guided-tour-gifs/use-get-language-gif'

/** Charging cards 3 dot menu options step component */
export const ChargingCardsMenuStep: React.FC = () => {
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('sm'))

  const { chargingCardMenuGif } = useGetLanguageMapperGif()

  return (
    <Box>
      <Trans i18nKey="emobility.tour.charging-cards-menu-options" components={{ strong: <strong /> }} />

      <Box mt={4} display="flex" justifyContent="left" alignItems="left">
        <Box component={'img'} src={chargingCardMenuGif} width={isMobile ? 200 : 300} />
      </Box>
    </Box>
  )
}
